export { default } from '@simplecy/frontend-types/components/HOC/withGuestRequired';
